import React, { Component, ReactNode } from 'react';
import FormicaLogo from '../../../icons/FormicaLogo';
import Sidebar from '../../../pages/Sidebar';
import GlobalSearchComponent from './GlobalSearchComponent';
import Icon from '../../../icons/Icon';
import ComponentWorkerComponent from '../ComponentWorkerComponent';
import JobContainer from './job/JobContainer';
import NotificationContainerComponent from './notification/NotificationContainerComponent';
import ProfileComponent from './profile/ProfileComponent';
import { RootState } from '../../../redux/store';
import { changeSidebarCollapse, toggleHamburgerMenu } from '../../../redux/actions/PageActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { FormicaProps, withFormica } from '../../../helpers/withFormica';

class Header extends Component<Props> {
  public render(): ReactNode {
    const { component, page } = this.props;
    return (
      <header className={'flex flex-col w-full  items-center justify-start h-[55px] m-0 p-0 bg-primary'}>
        <div className='flex w-full h-[55px] justify-between items-center rounded px-2 '>
          <div className={'flex w-full h-full gap-x-5 py-5 px-5 items-center relative'}>
            <span onClick={() => this.props.router.navigate('/')} className='cursor-pointer flex flex-row items-center'>
              <FormicaLogo />
              {process.env.REACT_APP_VERSION && (
                <span className='text-[10px] text-white/40 font-mono ml-1.5 pt-[9px] align-middle'>{process.env.REACT_APP_VERSION}</span>
              )}
            </span>
          </div>
          <div className={'h-full justify-center items-center  hidden lg:flex '}>
            <GlobalSearchComponent sidebar={false} />
          </div>
          <div onClick={this.onClickHamburgerMenu} className={'lg:hidden justify-end cursor-pointer'}>
            <Icon icon={'list'} size={16} color={'white'} />
          </div>
          <div className={'hidden lg:flex gap-x-4 items-center w-full justify-end'}>
            {component.component != null && component.id != null && <ComponentWorkerComponent key={`${component.component}_${component.id}`} />}
            <JobContainer />
            <NotificationContainerComponent />
            <ProfileComponent />
          </div>
        </div>
        <div
          className={`${!page.hamburgerMenuToggle ? 'hidden' : 'h-screen opacity-100'} inset-5 bg-white w-full lg:hidden transition-opacity text-center left-0 top-15`}
        >
          <Sidebar />
        </div>
      </header>
    );
  }

  private onClickHamburgerMenu = () => {
    const { page, toggleHamburgerMenu, changeSidebarCollapse } = this.props;
    toggleHamburgerMenu(!page.hamburgerMenuToggle);
    changeSidebarCollapse(false);
  };
}

interface Props extends ReduxProps, FormicaProps {
  component: any;
}

const mapStateToProps = (state: RootState) => ({
  page: state.page,
});
const mapDispatchToProps = {
  toggleHamburgerMenu,
  changeSidebarCollapse,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(Header));
